export const environment = {
  production: true,
  apiURL:'https://fortwayne-crm.thesmartcity311.com/CRM/',
  apiFileURL:'https://tst-mahelpline-upload.thesmartice.com/cc-fileuploads/',
  smartReportURL:"https://fortwayne-smartreporter.thesmartcity311.com/v1/",
  // smartReporterBackendURL:"http://172.16.1.30:7050/v1/",
  // smartReporterBackendURL:"https://smartreporter-prod.bluerock-f006a20f.eastus2.azurecontainerapps.io/v1/",
  apiURLThread:'https://fortwayne-mailreceiver.thesmartcity311.com/',
  backendurl : 'https://fortwayne-citizen-services.thesmartcity311.com/',
   customerportalurl:'https://fortwayne.thesmartcity311.com/',
   chatbotUrl:'https://fortwayne-smart-chat.thesmartcity311.com/',
  // JavaUrlEndPoint:'',
  // apiURL:'https://tst1-mahelpline-crm.thesmartice.com/CRM/',
  // apiFileURL:'http://172.16.1.63:8080/FileManagement/',
  localhost:window.location.protocol+"//"+window.location.hostname+":"+window.location.port,
  language:'en',
  loglevel: 'info',
  clientId:'38be101e-0789-48e4-bc4e-af489dd65fea',
  msalAuthority:'https://fortwayne311.b2clogin.com/fortwayne311.onmicrosoft.com/B2C_1_signin',
  pwresetmsalAuthority:'https://fortwayne311.b2clogin.com/fortwayne311.onmicrosoft.com/B2C_1_pwdreset',
  silentAPI:"https://fortwayne311.b2clogin.com/fortwayne311.onmicrosoft.com/api/user_impersonation",
  dev_mode: "FALSE"
};

